<template>
  <div>
    <b-row>
      <b-col class="wrapper fadeInDown">
        <b-row id="formContent">
          <b-col>

            <div v-if="banderaVale == 2">
              <b-row>
                <b-col class="card-option">
                  <img src="@/assets/logo.png" id="icon" alt="User Icon" class="mb-4 mt-4" />
                  <!-- Vale y password -->
                  <b-form-input size="sm" placeholder="Ingrese el número de vale" v-model="nFolioVale"
                    class="mb-3 mt-4"></b-form-input>
                  <!--<b-form-input size="sm" placeholder="Ingrese su contraseña" v-model="pass"></b-form-input>-->
                  <b-button @click="codigoProveedor()" variant="success" class="mb-4">Consultar Vales</b-button>
                </b-col>
              </b-row>
            </div>

            <div v-if="banderaVale == 1">
              <p></p>
              <h3>Vale de gasolina folio {{ nFolioVale }}</h3>
              <p></p>
              <b-row align-h="center" align="center">
                <!--UNIDAD-->
                <b-col cols="12" lg="10" class="card-option mb-2 ml-4 mr-4 mt-2">
                  <div>
                    <b-icon icon="truck" font-scale="2" class="mb-1 mt-1"></b-icon>
                    <h6 class="mb-2">Unidad</h6>
                    {{ unidad }}
                  </div>
                </b-col>

                <!--OPERADOR-->
                <b-col cols="12" lg="10" class="card-option mb-2 ml-4 mr-4 mt-2">
                  <div>
                    <b-icon icon="person" font-scale="2" class="mb-1 mt-1"></b-icon>
                    <h6 class="mb-2">Operador</h6>
                    {{ operador }}
                  </div>
                </b-col>

                <!--DATOS DE CARGA-->

                <b-col cols="12" lg="10" class="card-option mb-2 ml-4 mr-4 mt-2">
                  <div>
                    <b-icon icon="clipboard-check" font-scale="2" class="mb-1 mt-1"></b-icon>
                    <h6 class="mb-2">Datos Carga</h6>
                    {{ consumible }}
                    {{ litros }}
                  </div>
                </b-col>
              </b-row>
              <b-row align-h="center" align="center">
                <b-col>
                  <b-button class="mt-2 mb-4" size="lg" @click="despacharVale()" variant="success">Registrar
                    Carga</b-button>
                </b-col>
              </b-row>
            </div>

            <b-modal v-model="modalShow3" hide-footer header-text-variant="light" header-bg-variant="dark">
              <b-row align-h="center" align="center">
                <b-col cols="12" lg="12">
                  <h5>INGRESE LOS DATOS DEL TICKET DE BOMBA</h5>
                  <p></p>
                  <h5>Fecha:</h5>
                  <b-form-datepicker v-model="fechaCarga" placeholder="Ingresa la fecha"></b-form-datepicker>

                  <p></p>
                  <h5>No. Comprobante:</h5>
                  <b-form-input v-model="nFolioTicket" placeholder="Ingresa el número de comprobante"></b-form-input>

                  <!--
                  <p></p>
                  <h5>Hora de carga:</h5>
                  <b-form-timepicker v-model="horaCarga" placeholder="Ingresa la hora de carga"></b-form-timepicker>
                  -->

                  <h5>No. Litros:</h5>
                  <!--
                  <b-form-input type="number" number v-model="litrosCargadosValidacion"
                    placeholder="Ingresa el número de litros cargados" aria-describedby="input-live-feedback"
                    :state="validacionLitrosCarga"></b-form-input>

                  <b-form-invalid-feedback id="input-live-feedback">
                    El número de litros cargados es mayor al indicado en el vale
                  </b-form-invalid-feedback>
                  -->

                  <b-form-input type="number" number v-model="litrosCargadosValidacion"
                    placeholder="Ingresa el número de litros"></b-form-input>

                  <!--
                  
                  <div v-if="litrosCargadosValidacion > litros">

                    <b-alert show variant="danger">EL NUMERO DE LITROS CARGADOS ES MAYOR AL INDICADO EN EL VALE</b-alert>

                  </div>


                  <div v-if="litrosCargadosValidacion < litros">

                    <b-alert show variant="warning">EL NUMERO DE LITROS CARGADOS ES MENOR AL INDICADO EN EL VALE</b-alert>

                  </div>

                  -->



                  <!--
                  <p></p>
                  <h5>Folio vale de gasolina:</h5>
                  <b-form-input v-model="nFolioVale" placeholder="Ingresa el folio del vale de gasolina"></b-form-input>
                  -->

                  <p></p>
                  <h5>Total $:</h5>
                  <b-form-input type="number" number v-model="montoTotalCargado"
                    placeholder="Ingresa el monto total"></b-form-input>

                  <div v-if="montoTotalCargado > totalMontoVale">
                    <div v-if="Math.abs(totalMontoVale - montoTotalCargado) > litrosCargadosValidacion">

                      <b-alert show variant="warning">EL MONTO TOTAL CARGADO $$$ ES MAYOR AL INDICADO EN EL
                        VALE</b-alert>

                    </div>
                  </div>

                  <p></p>

                </b-col>



                <!--PARTE CAMARA-->
                <b-row align-h="center" align="center">
                  <b-col>
                    <div id="app" class="web-camera-container">
                      <!--SE COMENTA MOMENTANEAMENTE-->
                      <!--
                                            <div class="camera-button">
                                              <b-button type="button" class="button is-rounded"
                                                @click="toggleCamera">
                                                <span v-if="!isCameraOpen">Abrir Camara</span>
                                                <span v-else>Cerrar Camara</span>
                                              </b-button>
                                            </div>
                                            -->

                      <div v-show="isCameraOpen && isLoading" class="camera-loading">
                        <ul class="loader-circle">
                          <li></li>
                          <li></li>
                          <li></li>
                        </ul>
                      </div>

                      <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ flash: isShotPhoto }">
                        <div class="camera-shutter" :class="{ flash: isShotPhoto }"></div>

                        <video v-show="!isPhotoTaken" ref="camera" :width="337.5" :height="450" autoplay></video>

                        <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="337.5"
                          :height="450"></canvas>
                      </div>

                      <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
                        <div v-if="!this.isPhotoTaken">
                          <button type="button" class="button" @click="takePhoto">
                            <b-icon icon="camera" font-scale="5" class="mb-1 mt-4"></b-icon>
                          </button>
                        </div>

                        <div v-if="this.isPhotoTaken">
                          <button type="button" class="button" @click="takePhoto">
                            <b-icon icon="trash" font-scale="5" class="mb-1 mt-4"></b-icon>
                          </button>
                        </div>
                      </div>

                      <!--{{ "VALOR BANDERA: " + banderaSpinnerCamara }}-->

                      <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
                        <!--
                                              <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button"
                                                @click="saveImage">
                                                Guardar Foto
                                              </a>
                                              -->
                        <p></p>

                        <div v-if="banderaSpinnerCamara == 0">
                          <b-button variant="success" id="downloadPhoto" download="my-photo.jpg" class="button"
                            role="button" @click="saveImage">
                            Finalizar Carga
                          </b-button>
                        </div>
                        <div v-if="banderaSpinnerCamara == 1">
                          <strong>Espere un momento, por favor, se está validando su carga...</strong>
                          <p></p>
                          <b-spinner label="Espere un momento, por favor, se está validando su carga..."></b-spinner>
                        </div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-row>
            </b-modal>
            <div v-if="banderaSpinnerCamara == 2">
              <b-alert variant="success" show>SU CARGA SE HA VALIDADO CON EXITO</b-alert>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";

export default {

  /*
  computed: {
    validacionLitrosCarga() {
      return this.litrosCargadosValidacion <= this.litros ? true : false
    },
},
*/


  data() {
    return {
      //variables

      cliente: "teotihuacan",
      url: "https://ef23-2806-105e-7-5447-25c6-9d6a-4b45-a9bf.ngrok-free.app/",
      /*url: "https://ddf9-2806-105e-7-5447-3114-9459-d451-44ae.ngrok-free.app/",*/

      validacionProveedor: 1,
      banderaVale: 0,
      banderaCamera: 0,
      banderaBotonFinaliza: 0,
      claveProveedor: "",
      pass: "",
      modalShow: false,
      modalShow2: false,
      modalShow3: false,
      banderaOtraCantidad: "no activado",
      status: "not_accepted",
      nLitros: "",
      nFolioTicket: "",

      //Variables Camara
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      link: "#",

      fotoBase64: "",
      validacionDatos: "",
      fechaCarga: "",
      horaCarga: "",
      nFolioVale: "",

      unidad: "",
      operador: "",
      consumible: "",
      litros: "",
      litrosCargadosValidacion: "",
      banderaSpinnerCamara: 0,
      montoTotalCargado: "",
      totalMontoVale: ""
    };
  },

  created: function created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get("id");
    /*this.consultarVales(id)*/
    /*this.consultarVales(placa)*/

    if (id != null) {
      this.banderaVale = 1;
      this.modalShow2 = true;

      axios({
        method: 'post',
        url: this.url + 'imprimirvale',
        params: { "codeClient": this.cliente },
        data: {
          "folio": id
        }
      })
        .then((res) => {

          this.nFolioVale = res.data.folio,
            this.unidad = res.data.unidad.descUnidad,
            this.operador = res.data.operador,
            this.consumible = res.data.tipoConsumible,
            this.litros = res.data.nLitros,
            this.totalMontoVale = res.data.totalCombustible

        }).catch(err => {

          alert(err);
        });

    } else {
      this.banderaVale = 2;
    }
  },

  methods: {
    codigoProveedor() {


      this.banderaVale = 1;

      this.modalShow2 = true;

      axios({
        method: 'post',
        url: this.url + 'imprimirvale',
        params: { "codeClient": this.cliente },
        data: {
          "folio": this.nFolioVale
        }
      })
        .then((res) => {

          this.nFolioVale = res.data.folio,
            this.unidad = res.data.unidad.descUnidad,
            this.operador = res.data.operador,
            this.consumible = res.data.tipoConsumible,
            this.litros = res.data.nLitros,
            this.totalMontoVale = res.data.totalCombustible

        }).catch(err => {

          alert(err);
        });
    },

    despacharVale() {
      this.modalShow3 = true;
      this.toggleCamera();
    },

    //METODOS CAMARA

    toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },

    createCameraElement() {
      this.isLoading = true;

      /* Available values are 'user' (front camera), and 'environment' (back camera). */
      const constraints = (window.constraints = {
        audio: false,
        video: {
          facingMode: "environment",
        },
      });

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.isLoading = false;
          this.$refs.camera.srcObject = stream;
        })
        .catch((error) => {
          this.isLoading = false;
          alert(
            error + "May the browser didn't support or there is some errors."
          );
        });
    },

    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach((track) => {
        track.stop();
      });
    },

    takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      const context = this.$refs.canvas.getContext("2d");
      context.drawImage(this.$refs.camera, 0, 0, 337.5, 450);

      this.banderaBotonFinaliza = 1;
    },

    saveImage() {

      this.banderaSpinnerCamara = 1;

      const download = document.getElementById("downloadPhoto");
      const canvas = document
        .getElementById("photoTaken")
        .toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");
      download.setAttribute("href", canvas);

      this.fotoBase64 = canvas.replace("data:image/octet-stream;base64,", "");

      this.validacionDatos = {
        fotoTicket: this.fotoBase64,
        folioTicket: this.nFolioTicket,
        litrosCargados: this.litrosCargadosValidacion,
        fechaCarga: this.fechaCarga,
        horaCarga: this.horaCarga,
        folioVale: this.nFolioVale,
      };

      axios({
        method: "post",
        url: this.url + "confirmavale",
        params: { codeClient: this.cliente },
        data: this.validacionDatos,
      })
        .then(() => {
          this.registros = [];
          this.banderaSpinnerCamara = 2;
        })
        .catch((err) => {
          alert(err);
        });

      this.modalShow3 = false;

    },
  },
};
</script>

<style>
/* BASIC */

html {
  background-color: #ffffff;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #ffffff;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}

/* STRUCTURE */

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}

/* TABS */

h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}

/* FORM TYPOGRAPHY*/

input[type="button"],
input[type="submit"],
input[type="reset"] {
  background-color: #ffffff;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

input[type="button"]:hover,
input[type="submit"]:hover,
input[type="reset"]:hover {
  background-color: #ffffff;
}

input[type="button"]:active,
input[type="submit"]:active,
input[type="reset"]:active {
  -moz-transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -o-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}

input[type="text"] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

input[type="text"]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type="text"]:placeholder {
  color: #cccccc;
}

/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.card-option {
  box-shadow: 0px 5px 35px 5px #cccaca;
  border-radius: 15px;
  border-bottom: solid 4px rgb(68, 63, 173);
  background-color: white;
}

.fadeIn {
  opacity: 0;
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

/* OTHERS */

*:focus {
  outline: none;
}

#icon {
  width: 60%;
}
</style>
